// extracted by mini-css-extract-plugin
export default {"bottomNav":"AppDock_bottomNav__Rl9mB","navItem":"AppDock_navItem__5I4Tt","navItemActive":"AppDock_navItemActive__+vqNz"};